import dayjs from 'dayjs';
import { includes } from 'lodash/fp';

import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

export default function formatDateFilter(value, format = 'DD.MM.YYYY', locale = 'en') {
    if (includes(locale, ['de', 'fr', 'it'])) {
        dayjs.locale(locale);
    }
    return dayjs(value).format(format);
}
